// Import Mitt
import mitt from 'mitt';
import { useEffect } from 'react';
// Create an event emitter
const emitter = mitt();
export const useSub = (eventName, handler) => {
    const unsubscribe = () => {
        emitter.off(eventName, handler);
    };
    useEffect(() => {
        emitter.on(eventName, handler);
        return unsubscribe;
    });
    return unsubscribe;
};
export const usePub = () => {
    return (eventName, payload) => {
        emitter.emit(eventName, payload);
    };
};
